export const zeroTimer = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
}